module.exports = __webpack_public_path__ + "static/media/recommend.ab560eda.png";